module.exports = __webpack_public_path__ + "static/media/howitworks2.520de9e8.webp";